import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_BASE = process.env.REACT_APP_API_BASE;

export const fetchReferralHistoryItems = createAsyncThunk(
  "referral/history",
  async (id, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/referralhistory?referral_id=${id}`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "vendor",
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
       window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const addReferralHistory = createAsyncThunk(
  "referral/historyadd",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data);
    const res = await fetch(`${API_BASE}/api/referralhistory`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "vendor",
      },
      body: body,
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
       window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
